export class TableConfiguration {
    // true:with expanded panel, false: with link
    private _withDetail: boolean;

    // if "More" column should be displayed
    private _withMore: boolean;

    // permet de passer le composant à afficher dans les détails d'une ligne du tableau (Cas d'usage n°1)
    private _detailComponent: string;

    private _withIntegratedComponent = false;

    // passer le lien de la page détail (Cas d'usage n°2)
    private _detailUrl?: string;

    private _withExport = false; // Ce paramètre permet d'afficher ou non un bouton d'export de la liste complète non paginée

    private _withSearch = true; // Ce paramètre permet d'afficher ou non un input de recherche de la liste complète non paginée

    // permet d'afficher ou non en début de tableau un colonne permettant la multi sélection de ligne
    // (utile notamment pour l'action delete)
    private _withMultiSelect = true;

    // Ce paramètre permet de gérer ou non la pagination
    private _withPagination = true;

    // Ce paramètre permet de spécifier une classe CSS passé à la div Container du composant
    private _cssClass: string;

    // Ce paramètre permet de spécifier le nombre de lignes à afficher lorsque la pagination est activée
    private _pageLength = 25;

    // display or not the 'select' column
    private _withSelect = true;

    constructor($cssClass: string, $detailComponent: string, $withDetail?: boolean, $detailUrl?: string) {
        this.cssClass = $cssClass;
        this.detailComponent = $detailComponent;

        if ( $withDetail != null ) {
            // console.log('withDetail', $withDetail);
            this.withDetail = $withDetail;
        } else {
            this.withDetail = true;
        }

        if ( !!$detailUrl ) {
            this.detailUrl = $detailUrl;
        }
    }

    public get withDetail() {
        return this._withDetail;
    }
    public set withDetail(value) {
        this._withDetail = value;
    }

    public get withExport() {
        return this._withExport;
    }
    public set withExport(value) {
        this._withExport = value;
    }

    public get withSearch() {
        return this._withSearch;
    }
    public set withSearch(value) {
        this._withSearch = value;
    }

    public get withMultiSelect() {
        return this._withMultiSelect;
    }
    public set withMultiSelect(value) {
        this._withMultiSelect = value;
    }

    public get withPagination() {
        return this._withPagination;
    }
    public set withPagination(value) {
        this._withPagination = value;
    }

    public get pageLength(): number {
        return this._pageLength;
    }
    public set pageLength(value: number) {
        this._pageLength = value;
    }

    public get withSelect() {
        return this._withSelect;
    }
    public set withSelect(value: boolean) {
        this._withSelect = value;
    }

    public get withMore(): boolean {
      return this._withMore;
    }
    public set withMore(value: boolean) {
      this._withMore = value;
    }

    public get withIntegratedComponent() {
      return this._withIntegratedComponent;
    }
    public set withIntegratedComponent(value) {
      this._withIntegratedComponent = value;
    }

    /**
     * Getter detailComponent
     */
    public get detailComponent(): string {
        return this._detailComponent;
    }

    /**
     * Getter detailUrl
     */
    public get detailUrl(): string {
        return this._detailUrl;
    }

    /**
     * Getter cssClass
     */
    public get cssClass(): string {
        return this._cssClass;
    }

    /**
     * Setter detailComponent
     */
    public set detailComponent(value: string) {
        this._detailComponent = value;
    }

    /**
     * Setter detailUrl
     */
    public set detailUrl(value: string) {
        this._detailUrl = value;
    }

    /**
     * Setter cssClass
     */
    public set cssClass(value: string) {
        this._cssClass = value;
    }

}
